module.exports = __webpack_public_path__ + "img/banking-open-api-cover.dfb519ca.jpg";